export default __webpack_public_path__ + "0ea243ee4816015888a54023a666a2fe.pdf";